<template>
    <div v-html="content.content" class="contents" ref="contents"></div>
</template>

<script>
import { gsap, Power1 } from 'gsap';  // gsap 임포트
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger); // 추가된 부분
export default {
    data() {
        return {
            content: '',
        }
    },
    watch: {
        $route(to, from) {
            if (to.path != from.path) {
                this.getContent()
                setTimeout(() => {
                    let tableItems = document.querySelectorAll(".table-wrap")

                    tableItems.forEach((el) => {
                        this.checkTableWidth(el)
                    })

                    let tableItem = document.querySelectorAll(".table-wrap")

                    tableItem.forEach((el) => {
                        el.addEventListener("click", () => {
                            el.classList.add('on')
                        })
                    })
                }, 100)

            }
        }
    },
    methods: {
        getContent() {
            const path = this.$route.path
            let menuNo
            for (let i of this.menuList) {
                if (i.menuUrl == path && i.useYn == 'Y' && i.menuType == 'C') menuNo = i.menuNo
            }
            if (!menuNo) return
            this.axios.get(this.api.content.menuNo, {
                params: {
                    menuNo: menuNo
                }
            })
                .then(res => {
                    this.content = res.data
                    this.$nextTick(() => {
                        this.createScript(res.data.contentScript)
                    })
                })
        },
        createScript(item) {
            this.removeScript()
            const head = document.getElementsByTagName('head')[0]
            const script = document.createElement('script')
            script.id = 'cntntScript'
            script.textContent = item

            script.onload = () => {
                console.log('Script loaded and executed.')
            }

            script.onerror = () => {
                console.error('Script loading failed.')
            }
            // const createText = document.createTextNode(item);
            // script.appendChild(createText);
            head.appendChild(script)
        },
        removeScript() {
            const existingScript = document.querySelector('#cntntScript')
            if (existingScript) {
                existingScript.remove()
            }
        },
        checkTableWidth(element) {
            let table = element.querySelector('table')
            if (table && table.offsetWidth > element.offsetWidth) {
                element.classList.add('scroll')
            } else {
                element.classList.remove('scroll')
            }
        },
        // 여러 요소에 대해 checkTableWidth를 호출하는 새로운 메서드
        checkAllTableWidths() {
            const elements = document.querySelectorAll('.your-class') // .your-class를 적절한 선택자로 변경하세요.
            elements.forEach(element => {
                this.checkTableWidth(element)
            })
        },

        // 이전처리방침 아코디언
        toggleAccordion(event) {
            const target = event.currentTarget;
            const accordionBox = target.nextElementSibling;

            if (accordionBox.style.maxHeight) {
                accordionBox.style.maxHeight = null;
                target.classList.remove('active');
            } else {
                const allAccordions = document.querySelectorAll('.accordion_etc_box');
                allAccordions.forEach(acc => {
                    acc.style.maxHeight = null;
                    acc.previousElementSibling.classList.remove('active');
                });
                accordionBox.style.maxHeight = accordionBox.scrollHeight + "px";
                target.classList.add('active');
            }
        },
        scrollToHash(){
            const hash = location.hash
            if(hash){
                const headerY = document.querySelector('.header')?.clientHeight || 0
                const el = document.querySelector(hash)
                if(el){
                    const y = el.getBoundingClientRect().top + window.pageYOffset - headerY
                    window.scrollTo({top: y, behavior: 'smooth'})
                }
            }
        },
        waitForImagesLoad(callback) {
            const images = document.querySelectorAll("img");
            let loadedCount = 0;

            if (images.length === 0) {
                callback();
                return;
            }

            images.forEach((img) => {
                if (img.complete) {
                    loadedCount++;
                } else {
                    img.addEventListener("load", () => {
                        loadedCount++;
                        if (loadedCount === images.length) {
                            callback();
                        }
                    });

                    img.addEventListener("error", () => {
                        loadedCount++;
                        if (loadedCount === images.length) {
                            callback();
                        }
                    });
                }
            });

            // 모든 이미지가 이미 로드된 경우 바로 실행
            if (loadedCount === images.length) {
                callback();
            }
        }
    },
    async mounted() {
        // this.getContent();

        const path = this.$route.path
        let menuNo
        for (let i of this.menuList) {
            if (i.menuUrl == path && i.useYn == 'Y' && i.menuType == 'C') menuNo = i.menuNo
        }
        if (menuNo) {
            const response = await this.axios.get(this.api.content.menuNo, {
                params: {
                    menuNo: menuNo
                }
            })

            this.content = response.data
            const scriptStr = this.content.contentScript
            window.gsap = gsap
            window.al = alert
            this.$nextTick(()=>{
                const dynamicFunction = new Function(scriptStr);
                dynamicFunction();
                this.waitForImagesLoad(() => {
                    if (this.$route.path.indexOf('/intro/intro') > -1) this.scrollToHash();
                });
            })
        }

        // 이전처리방침 아코디언
        const accordionItems = document.querySelectorAll('.accordion_etc_item a[role="button"]');
        accordionItems.forEach(item => {
            item.addEventListener('click', this.toggleAccordion);
        });

    },
}
</script>